module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABFElEQVRIS73Wv27CMBDH8e8xoc5deY+OPABShcTGxtapQ4dko1tZWFFHxCPwAGy8DV0bVZUwStQ0BjnxH2J7tvTx7+6ks5DwqJyVpPJKDMiSgDVWhosO6lh08BaLCpqwaGAbFgXswnoHbVivoAvWG+iK9QL6YHeDvthdYAgWDIZiQaAnVqBYIDwBr96gNwYTWXFQOUvg3QsMxjJeEDb13nVaTwbsG3hoWd4FdbIbzCmhAfvihxFDZii2wECDOzEr2FLGM8JUPtirnDmw+0OtWCdo6dkvwkxDP4HnakAMZdRLb+yh44A06BuPsuZkw4wJHbH60Q1qSWacUk+sQeEIjF2+nP8lDcRcjKs7FZgKq3qYEivBC/m4go7GFW02AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/bianjiao2@2x.png
// module id = nuOn
// module chunks = 19